import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { RatingIcons } from '../../models/survey/RatingIcons';
import FormIconRating from '../form/FormIconRating';
import QuestionHeader from './QuestionHeader';
import { Typography } from '@material-ui/core';

const SubmissionIconRating = ({ name, number, questionText, ratingIcon, answers, readonly, isOptional }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
      <div style={{fontSize: 28}}>
        <Field
          name={`${name}.selectedAnswersIds[0]`}
          component={FormIconRating}
          values={answers.map(answer => ({ value: answer.id, name: answer.answerText }))}
          symbol={RatingIcons[ratingIcon].name}
          disabled={readonly}
        />
      </div>
    </div>
  </div>
);

SubmissionIconRating.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  ratingIcon: PropTypes.oneOf(Object.keys(RatingIcons)),
  answers: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
};

export default SubmissionIconRating;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionIconRating.js